<template>
  <AutoDialogDrawer placement="centre" modal dismissible @close="$emit('close')">
    <template #title
      >{{ translate('[singular]Activate') }} {{ translate('Version') }}
      {{ activatePolicy.version }}</template
    >
    <p>
      {{ translate('Are you sure you want to activate this login policy') }}:
      <span class="text-nowrap">{{ translate('Version') }} {{ activatePolicy.version }}?</span>
    </p>

    <p v-if="deactivatePolicy">
      <template v-if="language === 'nl-NL'">
        Je kan maar één inlogbeleid actief hebben, dus {{ translate('Version') }}
        {{ deactivatePolicy.version }} zal gedeactiveerd worden.
      </template>
      <template v-else>
        You can only have a single active login policy, so {{ translate('Version') }}
        {{ deactivatePolicy.version }} will be deactivated.
      </template>
    </p>

    <template v-if="errors.length > 0">
      <h5>Errors:</h5>
      <p v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</p>
    </template>

    <template #buttons>
      <BootstrapButton
        name="cancel"
        variant="secondary"
        :disabled="activating"
        @click="$emit('close')"
        >{{ translate('Cancel') }}</BootstrapButton
      >
      <BootstrapButton name="submit" variant="primary" :disabled="activating" @click="submit">
        {{ translate('Activate') }}
      </BootstrapButton>
    </template>
  </AutoDialogDrawer>
</template>

<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';
import {errorResponseToErrorMap} from '@/sphere/error';

const {translate, language} = useLocalisation();
const loginPolicyStore = useLoginPolicyStore();

const errors = ref<string[]>([]);

const props = defineProps<{
  activatePolicy: LoginPolicy;
  deactivatePolicy?: LoginPolicy;
}>();

const emit = defineEmits<{
  close: [];
}>();

const activating = ref(false);

async function submit() {
  errors.value = [];
  activating.value = true;
  try {
    await loginPolicyStore.activatePolicy(props.activatePolicy, props.deactivatePolicy);
    emit('close');
  } catch (err) {
    errors.value = errors.value.concat(...Object.values(errorResponseToErrorMap(err)));
  } finally {
    activating.value = false;
  }
}
</script>
